import gql from 'graphql-tag'

import {
  Query,
  QueryCourseArgs,
  CourseParticipantsCountArgs,
  CourseProgressArgs,
  CourseProgressEvaluationsArgs,
  Course,
} from '../types-graphql'
import { courseFragment, courseMonitoringListFragment } from './fragments'

export type TDataCourses = Pick<
  Query,
  'courses' | 'externalCourses' | '__typename'
>
export const COURSES = gql`
  query (
    $areaId: ID
    $q: CourseRansack
    $perPage: Int
    $page: Int
    $participantsQuery: CourseParticipantRansack
  ) {
    courses(areaId: $areaId, q: $q, perPage: $perPage, page: $page) {
      nodes {
        ...CourseMonitoringListFragment
      }
      pagesCount
      nodesCount
      hasNextPage
      hasPreviousPage
    }
  }
  ${courseMonitoringListFragment}
`
export type CourseBasic = Pick<
  Course,
  'name' | 'id' | 'synchronousCourse' | 'createdAt'
>

export type CourseBasicPage = {
  __typename?: 'CoursePage'
  nodes: Array<CourseBasic>
}

export type TDataCoursesBasicInfo = {
  courses: CourseBasicPage
  __typename?: 'Query' | undefined
}
export const COURSES_BASIC_INFO = gql`
  query Courses($q: CourseRansack, $perPage: Int, $page: Int) {
    courses(q: $q, perPage: $perPage, page: $page) {
      nodes {
        id
        name
        synchronousCourse {
          id
          synchronousCourseType
        }
        integrationCourse {
          id
          provider
        }
        createdAt
      }
    }
  }
`

export type TDataCourse = Pick<Query, 'course' | '__typename'>
export type QueryCourseAllArgs = QueryCourseArgs &
  CourseParticipantsCountArgs &
  CourseProgressArgs &
  CourseProgressEvaluationsArgs
export const COURSE = gql`
  query ($id: ID!, $areaId: ID, $participantsQuery: CourseParticipantRansack) {
    course(id: $id) {
      ...CourseFragment
      certificatesCount
      lessonsCount
      synchronousCourseEvaluationsCount
      integrationCourse {
        id
        provider
      }
    }
  }
  ${courseFragment}
`
